export default "__VITE_ASSET__Dd8bZ_bJ__"